import { render, staticRenderFns } from "./AssignmentsListing.vue?vue&type=template&id=79972082&scoped=true&"
import script from "./AssignmentsListing.vue?vue&type=script&lang=js&"
export * from "./AssignmentsListing.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsListing.vue?vue&type=style&index=0&id=79972082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79972082",
  null
  
)

export default component.exports